import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ScreenPrintingPage } from './pages/ScreenPrintingPage';
import { EmbroideryPage } from './pages/EmbroideryPage';
import { CustomApparelPage } from './pages/CustomApparelPage';
import { PersonalizedGiftsPage } from './pages/PersonalizedGiftsPage';
import { SchoolsTeamsPage } from './pages/SchoolsTeamsPage';
import { ProductsPage } from './pages/ProductsPage';
import { FundraisersPage } from './pages/FundraisersPage';
import { ContactPage } from './pages/ContactPage';
import { AccountPage } from './pages/AccountPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/services" element={<ServicesPage data-id="element-5" />} data-id="element-4" />
        <Route path="/services/screen-printing" element={<ScreenPrintingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/services/embroidery" element={<EmbroideryPage data-id="element-9" />} data-id="element-8" />
        <Route path="/services/custom-apparel" element={<CustomApparelPage data-id="element-11" />} data-id="element-10" />
        <Route path="/services/personalized-gifts" element={<PersonalizedGiftsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/schools-teams" element={<SchoolsTeamsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/custom-apparel" element={<CustomApparelPage data-id="element-17" />} data-id="element-16" />
        <Route path="/products" element={<ProductsPage data-id="element-19" />} data-id="element-18" />
        <Route path="/fundraisers" element={<FundraisersPage data-id="element-21" />} data-id="element-20" />
        <Route path="/contact" element={<ContactPage data-id="element-23" />} data-id="element-22" />
        <Route path="/account" element={<AccountPage data-id="element-25" />} data-id="element-24" />
      </Routes>
    </Router>;
}